import { CostItem } from '../../entities/Budget'
import { apiRequest } from '../client'

interface RawCostItem {
  costItem: string
  costItemCode: string
  costItemStickerId: string
}

type CostItemsResponse = RawCostItem[]

export const fetchCostItems = async (): Promise<CostItem[]> => {
  const response = await apiRequest('/costitems')

  if (response.status === 404) {
    throw new Error('Статьи бюджета не найдены')
  }

  if (!response.ok) {
    throw new Error('Не удалось загрузить статьи бюджета')
  }

  const rawItems = (await response.json()) as CostItemsResponse

  return rawItems.map(item => ({
    name: item.costItem,
    code: item.costItemCode,
    uid: item.costItemStickerId
  }))
}
